// extracted by mini-css-extract-plugin
export default {"optionsMenu":"UserMenu_optionsMenu__xyM4V"};